export default __webpack_public_path__ + "static/media/email.681a3c2d.gif";